import { useTranslation } from 'react-i18next';
import { TbArrowBackUp } from 'react-icons/tb';

export const BackButton: React.FC = () => {
	/*********************
	// #region Hooks
	**********************/
	const { t } = useTranslation();

	/*********************
	// #region Functions
	**********************/
	const back = () => history.back();

	/*********************
	// #region Template
	**********************/
	return (
		<div className="flex gap-1 items-center" onClick={back}>
			<TbArrowBackUp />
			<div>{t('general.goBack')}</div>
		</div>
	);
};
